var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaccination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FCE6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6866 39.5523L34.3775 32.4395C34.1972 32.0519 34.3652 31.5916 34.7528 31.4117C35.14 31.2313 35.6003 31.3993 35.7806 31.7866L39.0894 38.8998C39.2697 39.287 39.1017 39.7473 38.7145 39.9276C38.3269 40.108 37.867 39.9396 37.6866 39.5523Z",
    fill: "#00A9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2315 7.44712L22.9574 2.5497L20.3075 3.78051L22.5821 8.67754C23.4451 8.2768 24.3685 7.84786 25.2315 7.44712Z",
    fill: "#80D4EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3749 11.4368L28.12 8.30434L37.1852 27.8253L30.4402 30.9578L21.3749 11.4368Z",
    fill: "#DDE4F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8954 16.8667L30.6409 13.7343L37.1841 27.8253L30.4391 30.9577L23.8954 16.8667Z",
    fill: "#FF9E3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1695 23.9015L33.9149 20.769L37.1844 27.8245L30.4394 30.957L27.1695 23.9015Z",
    fill: "#E57200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.447 10.5439L26.0968 9.31347L27.5731 12.4924L24.9232 13.7228L23.447 10.5439Z",
    fill: "#80D4EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8751 14.6721C24.8824 13.7399 27.6145 12.471 29.6202 11.5396L30.6381 13.7316C28.6658 14.6478 25.8638 15.949 23.8935 16.8644L22.8751 14.6721Z",
    fill: "#E57200"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2864 1.18237L23.9567 0.473434C23.7669 0.0639581 23.2804 -0.113971 22.8709 0.0762702C22.3828 0.303051 20.5034 1.17602 18.4735 2.11888C18.0636 2.30912 17.8861 2.79525 18.0763 3.20473L18.4056 3.91367C18.5958 4.32314 19.082 4.50107 19.4914 4.31083C21.7195 3.27582 23.759 2.32898 23.8892 2.26822C24.2987 2.07798 24.4766 1.59185 24.2864 1.18237Z",
    fill: "#00A9E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1317 32.2365C36.0519 32.4863 35.8712 32.6913 35.6333 32.8021L35.2409 32.9844C35.003 33.0948 34.7293 33.1008 34.487 33.0003L30.4368 30.9549L37.1818 27.8224L36.1317 32.2365Z",
    fill: "#E57200"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8872 8.20973C28.5969 8.34477 21.0329 11.8577 20.8009 11.9653C20.3915 12.1556 19.9053 11.9776 19.7151 11.5681L19.3858 10.8592C19.1956 10.4497 19.3735 9.96361 19.783 9.77336C20.8903 9.25904 26.7751 6.52576 27.8693 6.01778C28.2787 5.82754 28.7649 6.00547 28.9551 6.41495L29.2844 7.12388C29.4746 7.53336 29.2967 8.01949 28.8872 8.20973Z",
    fill: "#00A9E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5316 20.3914L26.7835 19.8092C27.1711 19.6289 27.3391 19.1689 27.1588 18.7813C26.9785 18.3937 26.5182 18.2261 26.1309 18.406L24.8799 18.9882L25.5316 20.3914Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1134 22.6637C28.5011 22.4834 28.6691 22.0231 28.4888 21.6358C28.3085 21.2482 27.8481 21.0802 27.4609 21.2605L26.2083 21.8436L26.86 23.2467L28.1134 22.6637Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1456 27.3461C30.9653 26.9585 30.5049 26.7905 30.1177 26.9708L28.8611 27.5554L29.5128 28.959L30.7703 28.374C31.1575 28.1937 31.3255 27.7333 31.1456 27.3461Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4411 25.519C29.8284 25.3387 29.9964 24.8788 29.8161 24.4912C29.6358 24.1039 29.1758 23.9359 28.7882 24.1162L27.5336 24.6997L28.1853 26.1033L29.4411 25.519Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72227 12.6108V17.3331L1.88615 20.402C1.60964 20.6232 1.38643 20.9038 1.23304 21.2229C1.07964 21.5421 1 21.8916 1 22.2457V37.6389C1 38.2651 1.24876 38.8656 1.69156 39.3084C2.13436 39.7512 2.73492 40 3.36114 40H15.639C16.2653 40 16.8658 39.7512 17.3086 39.3084C17.7514 38.8656 18.0002 38.2651 18.0002 37.6389V22.2457C18.0002 21.8916 17.9205 21.5421 17.7671 21.2229C17.6138 20.9038 17.3905 20.6232 17.114 20.402L13.2779 17.3331V12.6108H5.72227Z",
    fill: "#4DAADD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1 23.9448H18.0002V35.2783H1V23.9448Z",
    fill: "#99DDF3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90286 6H12.0974C12.4105 6 12.7107 6.12438 12.9321 6.34578C13.1535 6.56718 13.2779 6.86746 13.2779 7.18057V9.77782H5.72229V7.18057C5.72229 6.86746 5.84667 6.56718 6.06807 6.34578C6.28947 6.12438 6.58975 6 6.90286 6Z",
    fill: "#FF9E3E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9863 8.83392H5.01394C4.36193 8.83392 3.83337 9.36247 3.83337 10.0145V12.3756C3.83337 13.0276 4.36193 13.5562 5.01394 13.5562H13.9863C14.6383 13.5562 15.1668 13.0276 15.1668 12.3756V10.0145C15.1668 9.36247 14.6383 8.83392 13.9863 8.83392Z",
    fill: "#99DDF3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 28.6668H10.4446V26.7779H8.55566V28.6668H6.66675V30.5557H8.55566V32.4446H10.4446V30.5557H12.3335V28.6668Z",
    fill: "#FFF9F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccination);
export default __webpack_public_path__ + "static/media/Vaccination.d5c451c52fa6b80333883e254ffb2803.svg";
export { ForwardRef as ReactComponent };